<template lang="pug">
.p-login-container
  .p-login-form
    .p-login__logo
      img(src='~@/assets/img/logo.svg')
    form
      ul
        li
          label(for='email') ID
          input#email(name='email', type='text', v-model='loginForm.email', placeholder='入力してください')
        li.u-margin__top--s
          label(for='password') PASS
          input#password(name='password', type='password', v-model='loginForm.password', placeholder='入力してください')
      .p-login_btn__area
        button(type='primary', @click.prevent='handleLogin', style='width:100%;margin-bottom:30px;', :loading='loading') ログインする
</template>

<script>
import * as api from '@/api/auth/login';
export default {
  name: 'PagesLogin',
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      loading: false,
    };
  },
  methods: {
    handleLogin() {
      this.loading = true;
      if (this.loginForm.email !== null && this.loginForm.password !== null) {
        api
          .post(this.loginForm)
          .then(() => {
            this.loading = false;
            this.$router.push({ path: '/' });
            console.log('success');
          })
          .catch((error) => {
            if (error.response.data.error_code === '1005') {
              this.$message('メールアドレスかパスワードに誤りがあります');
            } else if (error.response.data.error_message === 'illegal parameter: email') {
              this.$message('メールアドレスを確認してください');
            } else if (error.response.data.error_message === 'illegal parameter: password') {
              this.$message('パスワードを確認してください');
            }
            this.loading = false;
            return false;
          });
      }
    },
  },
};
</script>
